import FormattingTooltipItemButton from './FormattingTooltipItemButton';
export default FormattingTooltipItemButton;
